
import { Mixins, Component, Watch } from 'vue-property-decorator';
import {
  Card,
  Col,
  Button,
  Row,
  Tooltip,
} from 'element-ui';
import api from '@/api/verify';
import BsMixin from '@/views/Home/mixins/bsMixin';
import BScroll from 'better-scroll';
import bModal from './bModal.vue';
import listMixin from './listMixin';

@Component({
  components: {
    Card,
    Col,
    Button,
    Row,
    bModal,
    Tooltip,
  },
})

export default class cardList extends Mixins(listMixin, BsMixin) {
  private dialogVisible: boolean = false;

  private worksItem: any = [];

  private showFlag: boolean = false;

  private verifyTitle: string = '';

  private bs?: BScroll;

  verifyClick(item: any) {
    this.worksItem = item;
    this.dialogVisible = true;
    this.showFlag = false;
    this.verifyTitle = '作品审核';
  }

  viewVerifyList(item: any) {
    this.worksItem = item;
    this.dialogVisible = true;
    this.showFlag = true;
    this.verifyTitle = '作品审核记录';
  }

  public $refs!:{
  list: Element,
  wrapper: Element
 }

  mounted() {
    this.initBS(this.$refs.list);
    this.bs = this.initBS(this.$refs.list);
    this.bs.on('scrollEnd', (cood: any) => {
      if (cood.y === 0) return;
      const contentHeight: number = this.$refs.list.clientHeight;
      const wrapperHeight: number = Math.abs(this.$refs.wrapper.getBoundingClientRect().height);
      if (contentHeight + Math.abs(cood.y) > wrapperHeight - 10) {
        this.$emit('getScrollData');
      }
    });
  }

  /* eslint-disable class-methods-use-this */
  viewDetail(id: string, version: number) {
    if (version === 2) {
      window.open(`${process.env.VUE_APP_SCRATCH_2X}${id}`);
    } else {
      window.open(`${process.env.VUE_APP_SCRATCH_3X}${id}`);
    }
  }
}
